import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: colors.indigo[900],
    main: colors.indigo[500],
    light: colors.indigo[100]
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400']
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  // Status Presentation System (front/src/utils/StatusPresentation): the
  // ONLY color vocabulary any status→presentation mapping may reference —
  // explicit and deliberate rather than relying on MUI's undocumented
  // internal success/warning defaults (previously accessed defensively as
  // `theme.palette.success?.main || '#4caf50'` in several unrelated files).
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[700],
    light: colors.green[100]
  },
  warning: {
    contrastText: black,
    dark: colors.amber[900],
    main: colors.amber[700],
    light: colors.amber[100]
  },
  caution: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[700],
    light: colors.orange[100]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[700],
    light: colors.blue[100]
  },
  neutral: {
    contrastText: white,
    dark: colors.blueGrey[900],
    main: colors.blueGrey[600],
    light: colors.blueGrey[100]
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    link: colors.blue[600]
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#F4F6F8',
    paper: white
  },
  divider: colors.grey[200]
};
